@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.menu {
  display: flex;
  flex: 1 0 0;
  flex-direction: row;
  align-items: flex-start;

  .menu-items {
    display: flex;
    flex-direction: column;
    // fixes coupon and menu width for IE at dashboard
    width: 28%;
    position: sticky;
    top: 4.5rem;
    align-items: flex-end;
    margin-right: 3.75rem;

    @include mobile {
      display: none;
    }
  }

  .menu-item {
    color: $grey-text;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.75rem;
    text-decoration: none;
    cursor: pointer;

    &.active {
      &:hover {
        color: $ny-red;
      }
    }

    &:hover {
      color: #888888;
    }
  }

  .content {
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
  }

  .active {
    color: $ny-red;
  }
}